import React, { ReactNode } from "react";
import {
  LDProvider,
  LDContext,
  LDOptions,
  basicLogger,
  LDLogLevel,
} from "launchdarkly-react-client-sdk";

interface Props {
  children?: ReactNode;
}

export const LDClientProvider = ({ children }: Props) => {
  const context: LDContext = {
    kind: "user",
    anonymous: true,
  };

  const logLevel =
    (process.env.NEXT_PUBLIC_LaunchDarklyLogLevel as LDLogLevel) || "error";
  const options: LDOptions = {
    bootstrap: "localStorage",
    logger: basicLogger({ level: logLevel }),
  };

  return (
    <LDProvider
      context={context}
      options={options}
      clientSideID={
        process.env.NEXT_PUBLIC_LaunchDarklyClientKey ?? "undefined"
      }
    >
      {children}
    </LDProvider>
  );
};
